import { template } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { SemeiaMedicSession } from 'parog-web/services/session';
interface Signature {
    phone: string;
}
export default class PhoneLinkComponent extends Component<Signature> {
    @service
    session: SemeiaMedicSession;
    static{
        template(`
    {{#if this.session.medic.isSuperUser}}
      <a
        href='ringover://call/{{@phone}}/'
        target='_blank'
        rel='noopener noreferrer'
      >{{@phone}}</a>
    {{else}}
      <a href='tel:{{@phone}}'>{{@phone}}</a>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
